<template>
	<div>
		<div class="scenario-select-tsunami">
			<select class="form-control" v-model="selected" @change="changeScenario">
				<option value="0">0：調べたい場所を探す</option>
				<option value="1">1：津波到達時間マップを見る</option>
				<option value="2">2：津波波高マップを見る</option>
				<option value="3">3：浸水深マップを見る</option>
				<option value="4">4：浸水深が30cmに到達する時間マップを見る</option>
			</select>
		</div>
		<div class="scenario-btn">
			<button type="button" class="btn btn-primary" v-show="showBtnBack" @click="scenarioBack">←シナリオ戻る</button>
			<button type="button" class="btn btn-primary" v-show="showBtnGo" @click="scenarioGo">シナリオ進む→</button>
		</div>
		<div class="map-label-l" v-show="showMapLabel" @click="showLegend">{{ mapLabel }}</div>
		<div class="scenario-text" v-html="scenarioText"></div>
		<GlobalEvents
			v-if="showBtnGo"
			@keydown.enter.exact="scenarioGo"
		/>
	</div>
</template>

<script>
import {JSFrame} from 'jsframe';
import GlobalEvents from 'vue-global-events';

const jsFrame = new JSFrame();
var legendWin = null;

export default {
	components: {
		GlobalEvents
	},
	data() {
		return {
			selected: '0',
			showBtnBack: false,
			showBtnGo: true,
			showMapLabel: false,
			mapLabel: '',
			legendParam: {
				title: '',
				size: [],
				url: '',
			}
		}
	},
	props: {
		'mapData': {
			type: Object
		}
	},
	methods: {
		changeScenario: function() {
			console.log('this.selected='+this.selected);
			if (legendWin) {
				legendWin.hide();
			}
			switch (this.selected) {
				case '0':
					console.log('シナリオ0 selected');
					//シナリオボタンの表示制御
					this.showBtnBack = false;
					this.showBtnGo = true;

					//レイヤ切り替え
					this.$emit('changeLeftLayer', {value:'L201', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L211', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L211N', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L221', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L231', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L231N', display:false, checkedLayers:[], checkedAllLayers:[]});

					//地図ラベルの表示制御
					this.showMapLabel = false;
					this.mapLabel = '';

					break;
				case '1':
					console.log('シナリオ1 selected');
					//シナリオボタンの表示制御
					this.showBtnBack = true;
					this.showBtnGo = true;

					//レイヤ切り替え
					this.$emit('changeLeftLayer', {value:'L201', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L211', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L211N', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L221', display:true, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L231', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L231N', display:false, checkedLayers:[], checkedAllLayers:[]});

					//中心点のレイヤ属性取得
					this.$emit('centerGetLeft');

					//凡例ウィンドウの表示制御
					this.legendParam.title = '津波到達時間凡例';
					this.legendParam.size = [230, 320];
					this.legendParam.url = 'legend/tsunamiTime.html';

					//地図ラベルの表示制御
					this.showMapLabel = true;
					this.mapLabel = '津波到達時間';

					break;
				case '2':
					console.log('シナリオ2 selected');
					this.showBtnBack = true;
					this.showBtnGo = true;

					this.$emit('changeLeftLayer', {value:'L201', display:true, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L211', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L211N', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L221', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L231', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L231N', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('centerGetLeft');

					this.legendParam.title = '津波波高凡例';
					this.legendParam.size = [250, 360];
					this.legendParam.url = 'legend/tsunamiHeight.html';

					this.showMapLabel = true;
					this.mapLabel = '津波波高';
					break;
				case '3':
					console.log('シナリオ3 selected');
					this.showBtnBack = true;
					this.showBtnGo = true;

					this.$emit('changeLeftLayer', {value:'L201', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L211', display:true, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L211N', display:true, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L221', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L231', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L231N', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('centerGetLeft');

					this.legendParam.title = '浸水深凡例';
					this.legendParam.size = [250, 230];
					this.legendParam.url = 'legend/tsunamiDepth.html';

					this.showMapLabel = true;
					this.mapLabel = '浸水深';
					break;
				case '4':
					console.log('シナリオ4 selected');
					this.showBtnBack = true;
					this.showBtnGo = false;

					this.$emit('changeLeftLayer', {value:'L201', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L211', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L211N', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L221', display:false, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L231', display:true, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('changeLeftLayer', {value:'L231N', display:true, checkedLayers:[], checkedAllLayers:[]});
					this.$emit('centerGetLeft');

					this.legendParam.title = '浸水深が30cmに到達する時間凡例';
					this.legendParam.size = [230, 290];
					this.legendParam.url = 'legend/tsunamiTime30.html';

					this.showMapLabel = true;
					this.mapLabel = '浸水深が30cmに到達する時間';
					break;
			}
		},
		scenarioBack: function() {
			this.selected--;
			this.selected = String(this.selected);
			this.changeScenario();
		},
		scenarioGo: function() {
			this.selected++;
			this.selected = String(this.selected);
			this.changeScenario();
		},
		showLegend: function() {
			if (legendWin) {
				legendWin.hide();
			}
			legendWin = jsFrame.create({
				name: 'legend_win',
				title: this.legendParam.title,
				width: this.legendParam.size[0], height: this.legendParam.size[1],
				movable: true,
				resizable: true,
				url: this.legendParam.url
			});
			var x = window.innerWidth - 260;
			legendWin.setPosition(x, 20, 'LEFT_TOP');
			legendWin.show();
		}
	},
	computed: {
		//シナリオ解説文の表示
		scenarioText: function() {
			var text = '';
			switch (this.selected) {
				case '0':
					text = 'まずは地図をドラッグしたり、ズームしたりして、地図の中心を調べたい場所に合わせてください。<br>使い方が分からないときは、画面右下にある各種メニューの、「地図の使い方」を参考にしてください。';
					break;
				case '1':
					if (this.mapData.time) {
						var timeVal = this.mapData.time;
						var timeDist = this.mapData.timeDist;
						text = "地図の中心位置から最寄りの海岸線における津波到達時間は、<span style='color:#FF0000'><b>「" + Math.floor(timeVal/60) + "分」</b></span>です。この海岸線までの直線距離は<span style='color:#FF0000'><b>"+ (Math.round(timeDist*10)/10) +"メートル</b></span>です。<br>実際に発生する地震の震源の位置・大きさ等によって、実際の到達時間はこの予測と異なる場合がありますので、注意してください。";
					} else {
						text = "地図の中心位置付近に津波到達時間データは見つかりませんでした。<br>海岸線に近いエリアに地図を移動して下さい。";
					}
					break;
				case '2':
					if (this.mapData.height) {
						var heightVal = this.mapData.height;
						var heightDist = this.mapData.heightDist;
						text = "地図の中心位置から最寄りの海岸線における津波波高は、<span style='color:#FF0000'><b>「" + (Math.round(heightVal*10)/10) + "メートル」</b></span>です。この海岸線までの直線距離は<span style='color:#FF0000'><b>"+ (Math.round(heightDist*10)/10) +"メートル</b></span>です。<br>実際に発生する地震の震源の位置・大きさ等によって、実際の津波波高はこの予測と異なる場合がありますので、注意してください。";
					} else {
						text = "地図の中心位置付近に津波波高データは見つかりませんでした。<br>海岸線に近いエリアに地図を移動して下さい。";
					}
					break;
				case '3':
					if (this.mapData.depth) {
						var TFH = this.mapData.depth;
						text = "地図の中心位置の浸水深は、<span style='color:#FF0000'><b>" + TFH + "m</b></span>と予測されています。<br>実際に発生する地震の震源の位置・大きさ等によって、実際の浸水深はこの予測と異なる場合がありますので、注意してください。";
					} else {
						text = "この位置には浸水深データがありません。";
					}
					break;
				case '4':
					if (this.mapData.time30) {
						var TAT30 = this.mapData.time30;
						text = "地図の中心位置の浸水深が30cmに到達する時間は、<span style='color:#FF0000'><b>" + Math.floor(TAT30/60) + "分</b></span>と予測されています。<br>実際に発生する地震の震源の位置・大きさ等によって、実際の浸水深が30cmに到達する時間はこの予測と異なる場合がありますので、注意してください。";
					} else {
						text = "この位置には浸水深が30cmに到達する時間データがありません。";
					}
					break;
			}
			return text;
		}
	}
}
</script>

<style scoped>
@import "../../css/ScenarioSelect.css";
</style>
